// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1PJXC","header":"ReportDetails_header__3-SbZ","title":"ReportDetails_title__2mONe","left":"ReportDetails_left__2j3Vv"};